module.exports = __webpack_public_path__ + "img/AdobeStock_245360474.a90f2a23.jpeg";